import { Button } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

type Props = {
  backRoute?: string;
};

export const HistoryBackButton: FC<Props> = ({ backRoute }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    backRoute ? navigate(backRoute) : history.back();
  };

  return (
    <Button type="primary" onClick={onClick}>
      {t('history-back')}
    </Button>
  );
};
